/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, Output, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { faExclamationCircle, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { TaskAssignmentType } from '../../../../../enums/task-assignment-type.enum';
import { EmployeeService } from '../../../../../services/employee.service';

@Component({
  selector: 'app-task-assignee-detail',
  templateUrl: './task-assignee-detail.component.html',
  styleUrls: ['./task-assignee-detail.component.scss'],
  standalone: false
})
export class TaskAssigneeDetailComponent implements OnInit {
  @Input()
  assignees?: string[];

  @Input()
  assigneeType?: TaskAssignmentType;

  @Output()
  @ViewChild('missingAssigneeNoticeBox')
  missingAssigneeNoticeBox?: TemplateRef<any>;

  readonly TaskAssignmentType = TaskAssignmentType;

  faExclamationCircle = faExclamationCircle;
  faExclamationTriangle = faExclamationTriangle;

  constructor(private employeeService: EmployeeService) {}

  ngOnInit(): void {}

  getEmployeeName(id: string): string | undefined {
    return this.employeeService.getEmployeeUserNameFromID(id) ?? undefined;
  }

  getEmployeeGroupName(id: string): string | undefined {
    var grpName = this.employeeService.getEmployeeGroupNameFromID(id);
    return grpName ?? undefined;
  }

  getAssigneeLabel(
    assignedTo: string[],
    assignedToEmployeeOrGroup: TaskAssignmentType
  ): string | undefined {
    let label: string | undefined = undefined;

    if (assignedToEmployeeOrGroup === TaskAssignmentType.EMPLOYEE) {
      label = this.getEmployeeName(assignedTo[0]);
    } else if (assignedToEmployeeOrGroup === TaskAssignmentType.EMPLOYEEGROUP) {
      let groups = assignedTo
        .map((groupId) => this.getEmployeeGroupName(groupId))
        .filter((groupName) => groupName != undefined);
      if (groups.length > 0) {
        label = groups.join(', ');
      }
    }

    return label;
  }

  checkMissingAssignments(
    assignedTo: string[],
    assignedToEmployeeOrGroup: TaskAssignmentType
  ): number {
    let missingCount = 0;

    if (assignedToEmployeeOrGroup === TaskAssignmentType.EMPLOYEE) {
      if (!this.getEmployeeName(assignedTo[0])) {
        missingCount = 1;
      }
    } else if (assignedToEmployeeOrGroup === TaskAssignmentType.EMPLOYEEGROUP) {
      assignedTo.forEach((assignee) => {
        if (!this.getEmployeeGroupName(assignee)) {
          missingCount++;
        }
      });
    }

    return missingCount;
  }
}
